// Widget CSS
import '@/css/_elementor/widgets/creative_section.css';

// ..........................................................................................

import { RandomImagePositions } from '@/js/utilities/random-image-positions';

// ..........................................................................................
// ..........................................................................................

/* Hook into Elementor frontend init */
window.addEventListener('elementor/frontend/init', () => {
	elementorFrontend.hooks.addAction('frontend/element_ready/creative_section.default', (scope) => {
		const scopeEl = scope[0];
		// ...

		const marqueeContainer = scopeEl.querySelector('.marquee-container');
		if (!marqueeContainer) return;

		if (!window.elementor) {
			const groups = marqueeContainer.querySelectorAll('.marquee-group');
			groups.forEach((group) => {
				setTimeout(() => {
					group.classList.add('is-active');
				}, 100);
			});
		}

		// ...

		const sectionIcons = scopeEl.querySelector('.floating-icons');
		if (!sectionIcons) return;

		function updateRandomPositions() {
			new RandomImagePositions({
				container: sectionIcons,
				items: '.floating-icon',
				padding: 64,
				cellSize: 180,
				topRightGap: window.innerWidth >= 1024 ? { width: 300, height: 200 } : { width: 0, height: 0 },
			});
		}

		setTimeout(() => {
			sectionIcons.classList.add('is-ready');

			if (!sectionIcons.classList.contains('is-random')) return;

			// Initialize positions on load
			updateRandomPositions();
		}, 250);

		// ...
	});
});

// ..........................................................................................
